/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Index_Banner_HeadingInputs */

const en_admin_resources_index_banner_heading = /** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make your resources public`)
};

const de_admin_resources_index_banner_heading = /** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen veröffentlichen`)
};

const es_admin_resources_index_banner_heading = /** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz públicos tus recursos`)
};

const fr_admin_resources_index_banner_heading = /** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendez vos ressources publiques`)
};

/** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */
const it_admin_resources_index_banner_heading = en_admin_resources_index_banner_heading;

/** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */
const pt_br2_admin_resources_index_banner_heading = en_admin_resources_index_banner_heading;

/** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */
const pl_admin_resources_index_banner_heading = en_admin_resources_index_banner_heading;

/** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */
const hu_admin_resources_index_banner_heading = en_admin_resources_index_banner_heading;

/** @type {(inputs: Admin_Resources_Index_Banner_HeadingInputs) => LocalizedString} */
const ro_admin_resources_index_banner_heading = en_admin_resources_index_banner_heading;

/**
* | output |
* | --- |
* | "Make your resources public" |
*
* @param {Admin_Resources_Index_Banner_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_index_banner_heading = /** @type {((inputs?: Admin_Resources_Index_Banner_HeadingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Index_Banner_HeadingInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_index_banner_heading(inputs)
	if (locale === "de") return de_admin_resources_index_banner_heading(inputs)
	if (locale === "es") return es_admin_resources_index_banner_heading(inputs)
	if (locale === "fr") return fr_admin_resources_index_banner_heading(inputs)
	if (locale === "it") return it_admin_resources_index_banner_heading(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_index_banner_heading(inputs)
	if (locale === "pl") return pl_admin_resources_index_banner_heading(inputs)
	if (locale === "hu") return hu_admin_resources_index_banner_heading(inputs)
	return ro_admin_resources_index_banner_heading(inputs)
});
export { admin_resources_index_banner_heading as "admin.resources.index_banner_heading" }